import HumanAgentEntity, { HumanAgentStatus } from "../../domain/entities/human_agent.entity";

const fromJSON = (json: any): HumanAgentEntity => {
    return {
        id: json.id,
        agentId: json.internal_id,
        name: json.name,
        status: json.is_active ? HumanAgentStatus.active : HumanAgentStatus.inactive
    }
}

const HumanAgentDto = {
    fromJSON
}

export default HumanAgentDto;